<section class="closing-cta-section">
  @if (showImageSection()) {
    <div class="cta-image-section">
      <img [src]="peopleImageUrl()" alt="" class="cta-people-image" />
    </div>
  }

  <div class="cta-banner" [class.cta-banner--no-image]="!showImageSection()" [style.background-image]="bannerImageUrl() ? 'url(' + bannerImageUrl() + ')' : undefined">
    <div class="cta-content">
      <div class="cta-text">
        <h2 class="cta-heading" [style.color]="headingColor() ?? undefined">{{ headingDisplay() }}</h2>
        <p class="cta-subtext" [style.color]="subtextColor() ?? undefined">{{ subtext() | translateLang }}</p>
      </div>

      <app-button
        [label]="buttonLabel() | translateLang"
        [variant]="'yellow'"
        (clicked)="onButtonClick()"
        class="cta-button">
      </app-button>
    </div>
  </div>
</section>
